import { ServiceFieldType } from '@onlog-public/additional-services-types';
import {
  OptionsCache,
  optionLoaderProcessor,
} from '@pages/AdditionalServices/containers/services/optionsLoader/types';
import { ecoFeeLoader } from '@services/requests/searchLoaders/ecoFeeLoader';
import { EcoFeePackagesLoaderResponse } from '@services/requests/searchLoaders/ecoFeeLoader/EcoFeePackagesLoaderQuery';

/**
 * EcoFeePackageProcessor реализует процессор для загрузки упаковок экосбора
 */
export class EcoFeePackageProcessor implements optionLoaderProcessor {
  /**
   * GetType возвращает тип поля, для которого собран процессор
   */
  GetType(): ServiceFieldType {
    return 'package';
  }

  /**
   * LoadOptionsCache выполняет загрузку кэша определенного типа
   * В качестве аргумента принимает тип поля и идентификаторы для загрузки.
   *
   * @param id
   */
  async LoadOptionsCache(id?: string[]): Promise<OptionsCache<any>> {
    if (!id) {
      return { isPartialLoading: true, cache: {} };
    }

    const cache: OptionsCache<EcoFeePackagesLoaderResponse['items'][number]> = {
      isPartialLoading: true,
      cache: {},
    };

    const allVersions = await ecoFeeLoader().LoadPackagesByParams({ limit: 10000 });
    allVersions.map((v) => (cache.cache[v.id] = v));
    return cache;
  }
}
